import styles from './filter-chip.module.css';

/**
 * The X that removes a filter chip. Hand-rolled rather than the shared tag's
 * close button, which carries neither a test id nor the click event the chips
 * need to stop from reaching the chip itself.
 */
export const ChipCloseButton = ({
  onClick,
}: {
  onClick: (event: React.MouseEvent) => void;
}) => (
  <button
    type="button"
    aria-label="Remove filter"
    className={styles.chipClose}
    onClick={onClick}
    data-testid="clear-filter-chip"
  >
    <svg viewBox="0 0 512 512" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
      />
    </svg>
  </button>
);
